import { render, staticRenderFns } from "./botManagement.vue?vue&type=template&id=17226b94&scoped=true&"
import script from "./botManagement.vue?vue&type=script&lang=ts&"
export * from "./botManagement.vue?vue&type=script&lang=ts&"
import style0 from "./botManagement.vue?vue&type=style&index=0&id=17226b94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17226b94",
  null
  
)

export default component.exports